import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import "../../styles/Filter.css";
import { ApiCall, Colors, FilterApi, Web_url } from "../../common/Const";
import Checkbox from "@mui/material/Checkbox";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import "swiper/css";
import "swiper/css/navigation";
import Modal from "@mui/material/Modal";
import { MutatingDots } from "react-loader-spinner";
import store from "../../redux/Store";
import { useSelector } from "react-redux";
import Chip from "@mui/material/Chip";
import { useNavigate } from "react-router-dom";
import SkeletonEffect from "./homeComponents/SkeletonEffect";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import filterImage from "../../assets/filter.png";
import Trending from "./homeComponents/Trending";

function Filter() {
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [menuShow, setmenuShow] = useState(false);
  const RdxMenu = useSelector((state) => state.menu.value);
  const params = useSelector((state) => state.params);
  const { CollId, BudId, CatId, searchVal, jweType } = params;
  const [filterRes, setfilterRes] = useState([]);
  const [loader, setloader] = useState(false);
  const [NoData, setNoData] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const sort = useSelector((state) => state.sort);
  const fav = useSelector((state) => state.favCount);
  const [cusId, setcusId] = useState(user && user.id > 0 ? user.id : 0);
  const [HomeData, setHomeData] = useState([]);

  const [karatParams, setKaratParams] = useState(
    RdxMenu && Object.keys(RdxMenu).length > 0 && RdxMenu.gold_karat.length > 0
      ? RdxMenu.gold_karat
      : []
  );
  const [collectionData, setCollectionData] = useState([]);
  useEffect(() => {
    const collectionParams = {
      branch_type: "collection",
      branch_id: 1,
      customer_id: cusId,
      // page_number: 0,
    };
    ApiCall("webFindClick", collectionParams).then((data) => {
      setCollectionData(data);
    });
  }, []);

  const [goldColorParams, setGoldColorParams] = useState(
    RdxMenu &&
      Object.keys(RdxMenu).length > 0 &&
      RdxMenu.gold_color_id.length > 0
      ? RdxMenu.gold_color_id
      : []
  );
  // const [collectionParams, setCollectionParams] = useState(RdxMenu && Object.keys(RdxMenu).length > 0 && RdxMenu.collection_id.length > 0 ? RdxMenu.collection_id:[]);
  const [collectionParams, setCollectionParams] = useState(
    CollId != undefined && CollId > 0
      ? [String(CollId)]
      : RdxMenu &&
        Object.keys(RdxMenu).length > 0 &&
        RdxMenu.collection_id.length > 0
      ? RdxMenu.collection_id
      : []
  );
  const [occasionsParams, setOccasionsParams] = useState(
    RdxMenu && Object.keys(RdxMenu).length > 0 && RdxMenu.occasion_id.length > 0
      ? RdxMenu.occasion_id
      : []
  );
  const [categoryParams, setCategoryParams] = useState(
    CatId != undefined && CatId > 0
      ? [String(CatId)]
      : RdxMenu &&
        Object.keys(RdxMenu).length > 0 &&
        RdxMenu.category_id.length > 0
      ? RdxMenu.category_id
      : []
  );
  const [jewlTypeParams, setJewlTypeParams] = useState(
    jweType != undefined && jweType > 0
      ? [String(jweType)]
      : RdxMenu &&
        Object.keys(RdxMenu).length > 0 &&
        RdxMenu.jewellery_type_id.length > 0
      ? RdxMenu.jewellery_type_id
      : []
  );
  const [priceParams, setPriceParams] = useState(
    BudId != undefined && BudId > 0
      ? [String(BudId)]
      : RdxMenu &&
        Object.keys(RdxMenu).length > 0 &&
        RdxMenu.budget_id.length > 0
      ? RdxMenu.budget_id
      : []
  );
  const [JewlStyleParams, setJewlStyleParams] = useState(
    RdxMenu && Object.keys(RdxMenu).length > 0 && RdxMenu.style_id.length > 0
      ? RdxMenu.style_id
      : []
  );
  const [priceRangeParams, setPriceRangeParams] = useState(
    RdxMenu &&
      Object.keys(RdxMenu).length > 0 &&
      RdxMenu.price_range &&
      RdxMenu.price_range != ""
      ? RdxMenu.price_range
      : ""
  );
  const [weightParams, setWeightParams] = useState(
    RdxMenu && Object.keys(RdxMenu).length > 0 && RdxMenu.weight.length > 0
      ? RdxMenu.weight
      : []
  );
  // const [searchParams, setSearchParams] = useState(searchVal != undefined && searchVal !="" ? String(searchVal) : RdxMenu && Object.keys(RdxMenu).length > 0 && RdxMenu.search != "" ? RdxMenu.search:"");
  const [pageNumber, setpageNumber] = useState(0);
  const [sortParams, setSortParams] = useState([]);
  const [rangeVal, setrangeVal] = useState(0);
  const [Call, setCallFun] = useState("start");
  const [CallInit, setCallInit] = useState("");
  const [loadMore, setloadMore] = useState(true);
  const arrData = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

  const navigate = useNavigate();

  const [filterMenu, setFilterMenu] = useState(
    RdxMenu && Object.keys(RdxMenu).length > 0 ? RdxMenu : []
  );
  useEffect(() => {
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleClick = (data) => {
    navigate("/product-details", { state: { p_detail: data } });
  };

  useEffect(() => {
    FilterMenu();
    applyFilterFun();
    homeSection();
  }, [CallInit]);

  useEffect(() => {
    if (params && Object.keys(params).length > 0) {
      // console.log("part 1")
      applyFilterFunRdx();
    } else {
      if (Call == "start") {
        // console.log("part 3")
        applyFilterFun();
      } else {
        // console.log("part 2")
        applyFilterFunRdx();
      }
    }
    homeSection();
  }, [Call]);
  // }, [Call, params]);
  const [mobileCall, setmobileCall] = useState("hii");
  useEffect(() => {
    if (mobileCall != "hii") {
      const paramsPass = {
        customer_id: cusId,
        gold_karat: karatParams,
        gold_color_id: goldColorParams,
        occasion_id: occasionsParams,
        category_id:
          CatId != undefined && CatId > 0 ? [String(CatId)] : categoryParams,
        jewellery_type_id:
          jweType != undefined && jweType > 0
            ? [String(jweType)]
            : jewlTypeParams,
        budget_id: priceParams,
        style_id: JewlStyleParams,
        collection_id: collectionParams,
        weight: weightParams,
        page_number: pageNumber,
        sort: sortParams,
        price_range: priceRangeParams,
        search:
          searchVal != undefined && searchVal != "" ? String(searchVal) : "",
        sort: sort && sort.ratings != "" ? sort.ratings : "",
      };
      store.dispatch({ type: "setMenu", payload: paramsPass });
    }
  }, [mobileCall]);

  const FilterMenu = () => {
    ApiCall("filterMenu", {})
      .then((data) => {
        if (data.message == "Success") {
          setFilterMenu(data.result);
        }
      })
      .catch((err) => console.log(err));
  };

  // const clickFun = (value) => {
  //   setPriceRangeParams(value * 1000);
  //   setCallFun(Math.random().toString(36).slice(2, 7));
  // };

  const handleCheck = (state, set, id, value, type, mobile) => {
    console.log(state, set, id, value, type, mobile);
    const oldst = state.find((oldId) => oldId == id);
    if (oldst == undefined) {
      set([...state, id]);
    } else {
      set(state.filter((data) => data != id));
    }

    if (!mobile) {
      setCallFun(Math.random().toString(36).slice(2, 7));
      setmobileCall(Math.random().toString(36).slice(2, 7));
    } else {
      setmobileCall(Math.random().toString(36).slice(2, 7));
    }
  };
  const handleMenu = () => {
    setmenuShow(!menuShow);
  };

  const applyFilterFun = () => {
    setloader(true);
    // console.log("page no -->", page)
    // console.log("inital 01 col param -->", RdxMenu);
    const paramsPass =
      RdxMenu && Object.keys(RdxMenu).length > 0
        ? RdxMenu
        : {
            customer_id: cusId,
            gold_karat: karatParams,
            gold_color_id: goldColorParams,
            occasion_id: occasionsParams,
            category_id: categoryParams,
            jewellery_type_id: jewlTypeParams,
            budget_id: priceParams,
            style_id: JewlStyleParams,
            collection_id: collectionParams,
            weight: weightParams,
            page_number: pageNumber,
            // page_number: bottomTrack ? pageNumber + 20 : pageNumber,
            price_range: priceRangeParams,
            search:
              searchVal != undefined && searchVal != ""
                ? String(searchVal)
                : "",
            sort: sort && sort.ratings != "" ? sort.ratings : "",
          };
    // console.log("f 01 params -->", paramsPass)
    FilterApi("productFilter", paramsPass)
      .then((data) => {
        if (data.meassage == "Success") {
          if (data.result.length > 0) {
            if (data.result.length < 20) {
              setloadMore(false);
            }
            const dataVal = [...filterRes, ...data.result];
            let uniq = {};
            const val = dataVal.filter(
              (obj) => !uniq[obj.product_id] && (uniq[obj.product_id] = true)
            );
            // console.log("f 01 res -->",data.result);
            setfilterRes(val);
            // settotalCount(data.result.length);
            setloader(false);
            setNoData(false);
          }
          // console.log("Filter Response -->>", data.result);
        } else if (data.meassage == "No Products") {
          setNoData(true);
          setloader(false);
        }
      })
      .catch((err) => console.log(err));
  };

  const applyFilterFunRdx = () => {
    setloader(true);
    const paramsPass = {
      customer_id: cusId,
      gold_karat: karatParams,
      gold_color_id: goldColorParams,
      occasion_id: occasionsParams,
      category_id:
        CatId != undefined && CatId > 0 ? [String(CatId)] : categoryParams,
      jewellery_type_id:
        jweType != undefined && jweType > 0
          ? [String(jweType)]
          : jewlTypeParams,
      budget_id: priceParams,
      style_id: JewlStyleParams,
      collection_id: collectionParams,
      weight: weightParams,
      page_number: pageNumber,
      sort: sortParams,
      price_range: priceRangeParams,
      search:
        searchVal != undefined && searchVal != "" ? String(searchVal) : "",
      sort: sort && sort.ratings != "" ? sort.ratings : "",
    };
    // console.log("params Filter -->> fun calling 02", paramsPass);

    FilterApi("productFilter", paramsPass)
      .then((data) => {
        // console.log("Filter Response erere 02 -->>", data.result);
        if (data.meassage == "Success") {
          setfilterRes(data.result);
          if (data.result.length < 20) {
            setloadMore(false);
          }
          // console.log("Filter Response -->>", data.result);
          store.dispatch({ type: "setMenu", payload: paramsPass });
          setNoData(false);
          setloader(false);
        } else if (data.meassage == "No Products") {
          setNoData(true);
          setloader(false);
        }
      })
      .catch((err) => console.log(err));
    // setloader(false);
  };

  const clearFilterFun = () => {
    store.dispatch({ type: "ClearMenu" });
    store.dispatch({ type: "ClearParams" });
    store.dispatch({ type: "ClearSort" });
    setrangeVal(0);
    setKaratParams([]);
    setGoldColorParams([]);
    setCollectionParams([]);
    setOccasionsParams([]);
    setCategoryParams([]);
    setJewlTypeParams([]);
    setPriceParams([]);
    setJewlStyleParams([]);
    setWeightParams([]);
    setpageNumber(0);
    setCallInit(Math.random().toString(36).slice(2, 7));
  };

  const handlePage = () => {
    setpageNumber((prev) => prev + 20);
    setCallInit(Math.random().toString(36).slice(2, 7));
  };

  const handleFavList = (id, ind, val) => {
    let newValue = filterRes.map((value, index) => {
      if (ind === index) {
        value.fav_status = val == 0 ? 1 : 0;
      }
      return value;
    });
    setfilterRes(newValue);

    const favParams = { customer_id: cusId, product_id: id };
    if (val === 0) {
      ApiCall("addFav", favParams)
        .then((data) => {
          if (data.message == "Success") {
            store.dispatch({ type: "addfavCount", payload: fav.qty + 1 });
          }
        })
        .catch((err) => console.log(err));
    } else {
      ApiCall("removeFav", favParams)
        .then((data) => {
          if (data.message == "Success") {
            store.dispatch({ type: "addfavCount", payload: fav.qty - 1 });
          }
        })
        .catch((err) => console.log(err));
    }
  };

  const handleMostViewedItems = (id)=>{
      if (cusId === 0) {
        const guestviewedProducts =
          JSON.parse(sessionStorage.getItem("guestviewedProducts")) || [];

        if (guestviewedProducts.includes(id)) {
          console.log("You have already viewed this product.");
          return;
        }

        //  const viewedParams ={customer_id:cusId,product_id:id};
        const viewedParams = { product_id: id };

        console.log(viewedParams);
        ApiCall("most_viewed", viewedParams)
          .then((data) => {
            console.log(data.message);
            guestviewedProducts.push(id);
            sessionStorage.setItem(
              "guestviewedProducts",
              JSON.stringify(guestviewedProducts)
            );
          })
          .catch((err) => console.log(err));
      } else {
        const viewedProducts =
          JSON.parse(sessionStorage.getItem("viewedProducts")) || [];

        if (viewedProducts.includes(id)) {
          console.log("You have already viewed this product.");
          return;
        }

        //  const viewedParams ={customer_id:cusId,product_id:id};
        const viewedParams = { product_id: id };

        console.log(viewedParams);
        ApiCall("most_viewed", viewedParams)
          .then((data) => {
            console.log(data.message);
            viewedProducts.push(id);
            sessionStorage.setItem(
              "viewedProducts",
              JSON.stringify(viewedProducts)
            );
          })
          .catch((err) => console.log(err));
      } 
  };

  const handleSort = (e, type) => {
    store.dispatch({
      type: "setRatings",
      payload: e.target.value,
    });
    if (!type) {
      setCallFun(Math.random().toString(36).slice(2, 7));
    }
  };

  const homeSection = () => {
    const params =
      user && user.id > 0
        ? { customer_id: user.id }
        : cusId && cusId > 0
        ? { customer_id: cusId }
        : {};

    ApiCall("homeSection", params)
      .then((data) => {
        if (data.message == "Success") {
          setHomeData(data.result[5].data);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    homeSection();
  }, []);

  const handleApplyFilter = () => {
    setmenuShow(!menuShow);
    setCallFun(Math.random().toString(36).slice(2, 7));
  };
  return filterMenu.length > 0 ? (
    <>
      <Header
        display={true}
        calIn={CallInit}
        reRes={setCallInit}
        reload={setCallFun}
        make={false}
      />
      <div
        className="container-fluid pb-5"
        style={{ backgroundColor: Colors.bg_color, height: "auto" }}
      >
        <div className="row mb-5">
          {windowSize > 560 && (
            <div
              className={
                windowSize <= 768
                  ? "col-lg-3 col-md-3 col-sm-3 col-6"
                  : "col-lg-3 col-md-4 col-sm-3 col-6"
              }
            >
              <div className="fil-hd mb-0 d-flex flex-row justify-content-between">
                <span>Filter</span>
                <span onClick={clearFilterFun} className="clear-filter">
                  {RdxMenu && Object.keys(RdxMenu).length > 0 && (
                    <Chip
                      style={{
                        backgroundColor: Colors.Base_color,
                        color: Colors.white_color,
                        cursor: "pointer",
                      }}
                      label="Clear Filter"
                    />
                  )}{" "}
                </span>
              </div>
              <div
                className="fil-option-box rounded-top"
                style={{ backgroundColor: Colors.white_color }}
              >
                <p
                  className="various-hd mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Sort By
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      value={sort.ratings}
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="ratings"
                        control={
                          <Radio
                            color="warning"
                            value="ratings"
                            checked={sort.ratings == "ratings" ? true : false}
                            onChange={(e) => handleSort(e)}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Ratings"
                      />
                      {/* <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="popularity"
                        control={
                          <Radio
                            color="warning"
                            value="popularity"
                            checked={
                              sort.ratings == "popularity" ? true : false
                            }
                            onChange={(e) => handleSort(e)}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Popularity"
                      /> */}
                      <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="price_low"
                        control={
                          <Radio
                            color="warning"
                            value="price_low"
                            checked={sort.ratings == "price_low" ? true : false}
                            onChange={(e) => handleSort(e)}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Price(low to high)"
                      />
                      <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="price_high"
                        control={
                          <Radio
                            color="warning"
                            value="price_high"
                            checked={
                              sort.ratings == "price_high" ? true : false
                            }
                            onChange={(e) => handleSort(e)}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Price(high to low)"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                {/* <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Karat
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[0].data.length > 0 &&
                    filterMenu[0].data.map((data, i) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                key={i + data.id}
                                label={data.name}
                                value={data.id}
                                name={i + data.id}
                                // checked={data.id == 2 ? true: false}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.gold_karat.length > 0 &&
                                  RdxMenu.gold_karat.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.gold_karat.length > 0 &&
                                  RdxMenu.gold_karat.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    karatParams,
                                    setKaratParams,
                                    e.target.value,
                                    data.name,
                                    "karat"
                                  )
                                }
                              />
                            }
                            label={`${data.name} Karat`}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}
                {/* <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Gold Color
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[1].data.length > 0 &&
                    filterMenu[1].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.gold_color_id.length > 0 &&
                                  RdxMenu.gold_color_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.gold_color_id.length > 0 &&
                                  RdxMenu.gold_color_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    goldColorParams,
                                    setGoldColorParams,
                                    e.target.value,
                                    data.name,
                                    "color"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}
                {/* <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Collections
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[2].data.length > 0 &&
                    filterMenu[2].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.collection_id.length > 0 &&
                                  RdxMenu.collection_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.collection_id.length > 0 &&
                                  RdxMenu.collection_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    collectionParams,
                                    setCollectionParams,
                                    e.target.value,
                                    data.name,
                                    "collection"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}
                {/* <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Occasions
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[3].data.length > 0 &&
                    filterMenu[3].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.occasion_id.length > 0 &&
                                  RdxMenu.occasion_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.occasion_id.length > 0 &&
                                  RdxMenu.occasion_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    occasionsParams,
                                    setOccasionsParams,
                                    e.target.value,
                                    data.name,
                                    "occasions"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Category
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[4].data.length > 0 &&
                    filterMenu[4].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.category_id.length > 0 &&
                                  RdxMenu.category_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.category_id.length > 0 &&
                                  RdxMenu.category_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    categoryParams,
                                    setCategoryParams,
                                    e.target.value,
                                    data.name,
                                    "category"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
                {/* <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Jewellery Type
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[5].data.length > 0 &&
                    filterMenu[5].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.jewellery_type_id.length > 0 &&
                                  RdxMenu.jewellery_type_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.jewellery_type_id.length > 0 &&
                                  RdxMenu.jewellery_type_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    jewlTypeParams,
                                    setJewlTypeParams,
                                    e.target.value,
                                    data.name,
                                    "jewelType"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}

                <p
                  className="various-hd mt-3 mb-0"
                  style={{ color: Colors.Base_color }}
                >
                  Price
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {/* <div className="d-flex flex-column">
                    <Slider
                      step={25}
                      defaultValue={rangeVal}
                      onChange={clickFun}
                    />
                    <div className="d-flex flex-row justify-content-between">
                      <small
                        className="p-2 range-text"
                        style={{ color: "gray" }}
                      >
                        10k
                      </small>
                      <small
                        className="p-2 range-text"
                        style={{ color: "gray" }}
                      >
                        50k
                      </small>
                      <small
                        className="p-2 range-text"
                        style={{ color: "gray" }}
                      >
                        1 lks
                      </small>
                    </div>
                  </div> */}
                  {filterMenu[6].data.length > 0 &&
                    filterMenu[6].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                // label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.budget_id.length > 0 &&
                                  RdxMenu.budget_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.budget_id.length > 0 &&
                                  RdxMenu.budget_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    priceParams,
                                    setPriceParams,
                                    e.target.value,
                                    data.name,
                                    "price"
                                  )
                                }
                              />
                            }
                            label={
                              "₹ " +
                              data.name.split("-")[0] +
                              " - " +
                              "₹" +
                              data.name.split("-")[1]
                            }
                          />
                        </FormGroup>
                      );
                    })}
                </div>

                {/* <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Jewellery Style
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[7].data.length > 0 &&
                    filterMenu[7].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.style_id.length > 0 &&
                                  RdxMenu.style_id.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.style_id.length > 0 &&
                                  RdxMenu.style_id.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    JewlStyleParams,
                                    setJewlStyleParams,
                                    e.target.value,
                                    data.name,
                                    "jewelStyle"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}

                {/* <p
                  className="various-hd mt-3"
                  style={{ color: Colors.Base_color }}
                >
                  Weight
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                  }}
                >
                  {filterMenu[8].data.length > 0 &&
                    filterMenu[8].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.weight.length > 0 &&
                                  RdxMenu.weight.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.weight.length > 0 &&
                                  RdxMenu.weight.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    weightParams,
                                    setWeightParams,
                                    e.target.value,
                                    data.name,
                                    "weight"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div> */}
              </div>
            </div>
          )}

          <div
            className={
              windowSize <= 768
                ? "col-lg-9 col-md-9 col-sm-9 col-12 box-2-fil"
                : "col-lg-9 col-md-8 col-sm-9 col-12 box-2-fil"
            }
            style={{ padding: 0 }}
          >
            <div className="d-flex flex-row align-items-center justify-content-between">
              <p className="fil-res-hd mb-0">Products</p>
              {windowSize < 560 && (
                <div className="d-flex flex-row align-items-center justify-content-center">
                  <img
                    src={filterImage}
                    alt="filter"
                    onClick={handleMenu}
                    width={25}
                  />
                  <span onClick={clearFilterFun} className="clear-filter mx-3">
                    {RdxMenu && Object.keys(RdxMenu).length > 0 && (
                      <Chip
                        style={{
                          backgroundColor: Colors.Base_color,
                          color: Colors.white_color,
                          cursor: "pointer",
                        }}
                        label="Clear Filter"
                      />
                    )}{" "}
                  </span>
                </div>
              )}
            </div>

            <div
              className="fil-res-box"
              // onScroll={handleScroll}
            >
              {loader ? (
                <div className="container row d-flex align-items-center justify-content-start">
                  {arrData.map((data) => {
                    return (
                      <div
                        className={
                          menuShow
                            ? "col-sm-12 col-12 col-md-4 col-lg-3 mb-3 d-flex align-items-center justify-content-center"
                            : "col-sm-12 col-6 col-md-4 col-lg-3 mb-3 d-flex align-items-center justify-content-center"
                        }
                      >
                        <SkeletonEffect
                          width={"220px"}
                          height={"270px"}
                          className={"card mx-2"}
                        />
                        {/* <SkeletonEffect width={"150px"} height={"170px"} className={"card mx-2"} /> */}
                      </div>
                    );
                  })}
                </div>
              ) : NoData ? (
                <div
                  className="d-flex align-items-center justify-content-center flex-column"
                  style={{ height: "50%" }}
                >
                  <h1 className="no-data">No results found!</h1>
                  <button
                    onClick={clearFilterFun}
                    className="btn"
                    style={{
                      backgroundColor: Colors.Base_color,
                      color: "#fff",
                    }}
                  >
                    Browse New Arrivals
                  </button>
                </div>
              ) : (
                <>
                  <div className="container">
                    {filterRes.length > 0 ? (
                      <div className="row d-flex align-items-center justify-content-start">
                        {filterRes.map((data, i) => {
                          return (
                            <div
                              className={
                                menuShow
                                  ? "col-sm-12 col-12 col-md-4 col-lg-3 mb-3 d-flex align-items-center justify-content-center"
                                  : "col-sm-12 col-6 col-md-4 col-lg-3 mb-3 d-flex align-items-center justify-content-center"
                              }
                              style={{ padding: 0 }}
                            >
                              <div
                                className="card"
                                style={{
                                  width:
                                    windowSize <= 1024
                                      ? "10rem"
                                      : windowSize <= 769
                                      ? "10rem"
                                      : "12rem",
                                  border: `1px solid ${Colors.Base_color}`,
                                  borderRadius: "25px",
                                  overflow: "hidden",
                                }}
                                role={"button"}
                              >
                                <div
                                  className="d-flex justify-content-end"
                                  style={{
                                    position: "absolute",
                                    top: 6,
                                    right: 6,
                                    zIndex: 100,
                                  }}
                                >
                                  {user &&
                                    user.id > 0 &&
                                    (data.fav_status == 1 ? (
                                      <i
                                        class="fa-solid fa-heart"
                                        style={{
                                          color: Colors.Base_color,
                                          margin: "8px 9px 5px 0px",
                                        }}
                                        // onClick={() => handleFavList(false, data.product_id)}
                                        onClick={() =>
                                          handleFavList(
                                            data.product_id,
                                            i,
                                            data.fav_status
                                          )
                                        }
                                        //
                                      ></i>
                                    ) : (
                                      <i
                                        class="fa-regular fa-heart"
                                        style={{
                                          color: Colors.Base_color,
                                          margin: "8px 9px 5px 0px",
                                        }}
                                        // onClick={() => handleFavList(true, data.product_id)}
                                        onClick={() =>
                                          handleFavList(
                                            data.product_id,
                                            i,
                                            data.fav_status
                                          )
                                        }
                                      ></i>
                                    ))}
                                </div>
                                <img
                                  src={
                                    Web_url.Domain_url +
                                    data.product_image[0].url
                                  }
                                  style={{ position: "relative" }}
                                  className="card-img-top "
                                  alt="..."
                                  // height="170px"
                                  onClick={() =>{handleClick(data);handleMostViewedItems(data.product_id)}}
                                />
                                <div
                                  className="card-body py-2 px-3 d-flex flex-column"
                                  onClick={() => {handleClick(data);;handleMostViewedItems(data.product_id)}}
                                >
                                  <p
                                    className="card-title trd-title text-truncate"
                                    style={{
                                      color: Colors.Base_color,
                                      marginBottom: "4px",
                                    }}
                                  >
                                    {data.product_name}
                                  </p>
                                  <p
                                    className="card-text"
                                    style={{
                                      color: "#000",
                                      marginBottom: "0px",
                                    }}
                                  >
                                    ₹ {data.product_price}
                                  </p>
                                  <div className="d-flex justify-content-start card-offer-fil">
                                    <span
                                      className=""
                                      style={{
                                        color: Colors.Base_color,
                                      }}
                                    >
                                      {data.discount} % Offer
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div
                        className="d-flex align-items-center justify-content-center flex-column"
                        style={{ height: "100vh" }}
                      >
                        {/* <img src={images.noData} alt="No data" className="img-fluid" /> */}
                        <h1 className="no-data">No results found!</h1>
                        <button
                          onClick={clearFilterFun}
                          className="btn"
                          style={{
                            backgroundColor: Colors.Base_color,
                            color: "#fff",
                          }}
                        >
                          Browse New Arrivals
                        </button>
                      </div>
                    )}
                  </div>
                  {loadMore && (
                    <div className="d-flex justify-content-center">
                      {" "}
                      <button
                        className="btn"
                        onClick={handlePage}
                        style={{
                          backgroundColor: Colors.Base_color,
                          color: Colors.white_color,
                        }}
                      >
                        load More
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className="pt-5"
          style={{ borderTop: `1px solid ${Colors.Base_color}` }}
        >
          <Trending
            windowSize={windowSize}
            trendingData={HomeData.length > 0 ? HomeData : null}
          />
        </div>
        <div
          className="d-flex flex-column mt-3"
          style={{ paddingLeft: "5%", paddingRight: "5%" }}
        >
          <div className="d-flex flex-column gap-3">
            <span className="about_product">Theni Kamadhenu Collections</span>
            <span className="descriptions">
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Nulla vulputate suscipit diam at congue.
              Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia
              tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula.
              Morbi ante lacus, tincidunt in purus non, fringilla ornare metus.
              Duis blandit urna non pretium maximus. Sed lacus arcu, convallis
              eu ex et, volutpat aliquet turpis.
            </span>
          </div>
          {/* <div className="d-flex flex-column gap-3 mt-5">
            <span className="about_product">Jeleso Collections</span>
            <span className="descriptions">
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Nulla vulputate suscipit diam at congue.
              Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia
              tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula.
              Morbi ante lacus, tincidunt in purus non, fringilla ornare metus.
              Duis blandit urna non pretium maximus. Sed lacus arcu, convallis
              eu ex et, volutpat aliquet turpis.
            </span>
          </div> */}
          <div className="d-flex flex-column gap-3 mt-5 mb-5">
            <span className="about_product">Theni Kamadhenu Collections</span>
            <span className="descriptions">
              Loremipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              quis elit bibendum, posuere velit nec, placerat magna. Class
              aptent taciti sociosqu ad litora torquent per conubia nostra, per
              inceptos himenaeos. Nulla vulputate suscipit diam at congue.
              Aliquam sit amet elit lacus. Aliquam eget velit faucibus, lacinia
              tellus vitae, posuere felis. Vestibulum sit amet pulvinar ligula.
              Morbi ante lacus, tincidunt in purus non, fringilla ornare metus.
              Duis blandit urna non pretium maximus. Sed lacus arcu, convallis
              eu ex et, volutpat aliquet turpis.
            </span>
          </div>
        </div>
        <div>
          <Modal
            open={menuShow}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <div className="d-flex flex-column justify-content-center align-items-center my-3">
              {/* <p className="fil-hd mb-0">Filter</p> */}
              <div
                className="d-flex flex-row justify-content-end pt-3 px-2"
                style={{ backgroundColor: "white", width: "350px" }}
              >
                <i
                  onClick={() => setmenuShow(!menuShow)}
                  class="fa-solid fa-xmark mx-3 fs-3"
                ></i>
              </div>

              <div
                className="fill-model"
                style={{
                  backgroundColor: Colors.white_color,
                  width: "350px",
                }}
              >
                <p
                  className="various-hd mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Sort By
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  <FormControl>
                    <RadioGroup
                      aria-labelledby="demo-radio-buttons-group-label"
                      defaultValue="female"
                      value={sort.ratings}
                      name="radio-buttons-group"
                    >
                      <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="ratings"
                        control={
                          <Radio
                            color="warning"
                            value="ratings"
                            checked={sort.ratings == "ratings" ? true : false}
                            onChange={(e) => handleSort(e, "mobile")}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Ratings"
                      />
                      {/* <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="popularity"
                        control={
                          <Radio
                            color="warning"
                            value="popularity"
                            checked={
                              sort.ratings == "popularity" ? true : false
                            }
                            onChange={(e) => handleSort(e, "mobile")}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Popularity"
                      /> */}
                      <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="price_low"
                        control={
                          <Radio
                            color="warning"
                            value="price_low"
                            checked={sort.ratings == "price_low" ? true : false}
                            onChange={(e) => handleSort(e, "mobile")}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Price(low to high)"
                      />
                      <FormControlLabel
                        style={{ color: "#B2969E" }}
                        value="price_high"
                        control={
                          <Radio
                            color="warning"
                            value="price_high"
                            checked={
                              sort.ratings == "price_high" ? true : false
                            }
                            onChange={(e) => handleSort(e, "mobile")}
                            sx={{
                              color: Colors.Base_color,
                              "&.Mui-checked": {
                                color: Colors.Base_color,
                              },
                            }}
                          />
                        }
                        label="Price(high to low)"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Karat
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[0].data.length > 0 &&
                    filterMenu[0].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.gold_karat.length > 0 &&
                                  RdxMenu.gold_karat.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.gold_karat.length > 0 &&
                                  RdxMenu.gold_karat.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    karatParams,
                                    setKaratParams,
                                    e.target.value,
                                    data.name,
                                    "karat",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={`${data.name} Karat`}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Gold Color
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[1].data.length > 0 &&
                    filterMenu[1].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.gold_color_id.length > 0 &&
                                  RdxMenu.gold_color_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.gold_color_id.length > 0 &&
                                  RdxMenu.gold_color_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    goldColorParams,
                                    setGoldColorParams,
                                    e.target.value,
                                    data.name,
                                    "color",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Collections
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[2].data.length > 0 &&
                    filterMenu[2].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.collection_id.length > 0 &&
                                  RdxMenu.collection_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.collection_id.length > 0 &&
                                  RdxMenu.collection_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    collectionParams,
                                    setCollectionParams,
                                    e.target.value,
                                    data.name,
                                    "collection",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Occasions
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[3].data.length > 0 &&
                    filterMenu[3].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.occasion_id.length > 0 &&
                                  RdxMenu.occasion_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.occasion_id.length > 0 &&
                                  RdxMenu.occasion_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    occasionsParams,
                                    setOccasionsParams,
                                    e.target.value,
                                    data.name,
                                    "occasions",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Category
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[4].data.length > 0 &&
                    filterMenu[4].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.category_id.length > 0 &&
                                  RdxMenu.category_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.category_id.length > 0 &&
                                  RdxMenu.category_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    categoryParams,
                                    setCategoryParams,
                                    e.target.value,
                                    data.name,
                                    "category",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Jewellery Type
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[5].data.length > 0 &&
                    filterMenu[5].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.jewellery_type_id.length > 0 &&
                                  RdxMenu.jewellery_type_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.jewellery_type_id.length > 0 &&
                                  RdxMenu.jewellery_type_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    jewlTypeParams,
                                    setJewlTypeParams,
                                    e.target.value,
                                    data.name,
                                    "jewelType",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>

                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Price
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {/* <div className="d-flex flex-column">
                    <Slider
                      step={25}
                      defaultValue={rangeVal}
                      onChange={clickFun}
                    />
                    <div className="d-flex flex-row justify-content-between">
                      <small
                        className="p-2 range-text"
                        style={{ color: "gray" }}
                      >
                        10k
                      </small>
                      <small
                        className="p-2 range-text"
                        style={{ color: "gray" }}
                      >
                        50k
                      </small>
                      <small
                        className="p-2 range-text"
                        style={{ color: "gray" }}
                      >
                        1lks
                      </small>
                    </div>
                  </div> */}
                  {filterMenu[6].data.length > 0 &&
                    filterMenu[6].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.budget_id.length > 0 &&
                                  RdxMenu.budget_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.budget_id.length > 0 &&
                                  RdxMenu.budget_id.includes(
                                    String(data.id)
                                  ) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    priceParams,
                                    setPriceParams,
                                    e.target.value,
                                    data.name,
                                    "price",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>

                <p
                  className="various-hd mt-3 mb-1"
                  style={{ color: Colors.Base_color }}
                >
                  Jewellery Style
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                    borderBottom: `1px solid ${Colors.Base_color}`,
                  }}
                >
                  {filterMenu[7].data.length > 0 &&
                    filterMenu[7].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.style_id.length > 0 &&
                                  RdxMenu.style_id.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.style_id.length > 0 &&
                                  RdxMenu.style_id.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    JewlStyleParams,
                                    setJewlStyleParams,
                                    e.target.value,
                                    data.name,
                                    "jewelStyle",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>

                <p
                  className="various-hd mt-3"
                  style={{ color: Colors.Base_color }}
                >
                  Weight
                </p>
                <div
                  style={{
                    paddingBottom: "20px",
                  }}
                >
                  {filterMenu[8].data.length > 0 &&
                    filterMenu[8].data.map((data) => {
                      return (
                        <FormGroup>
                          <FormControlLabel
                            style={{ color: "#B2969E" }}
                            control={
                              <Checkbox
                                label={data.name}
                                value={data.id}
                                sx={{
                                  color: "#126a38",
                                  "&.Mui-checked": {
                                    color: "#126a38",
                                  },
                                }}
                                icon={
                                  RdxMenu &&
                                  RdxMenu.weight.length > 0 &&
                                  RdxMenu.weight.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                checkedIcon={
                                  RdxMenu &&
                                  RdxMenu.weight.length > 0 &&
                                  RdxMenu.weight.includes(String(data.id)) ? (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square-check check-box-i"
                                    />
                                  ) : (
                                    <i
                                      style={{ color: Colors.Base_color }}
                                      className="fa-regular fa-square check-box-i"
                                    />
                                  )
                                }
                                onChange={(e) =>
                                  handleCheck(
                                    weightParams,
                                    setWeightParams,
                                    e.target.value,
                                    data.name,
                                    "weight",
                                    "mobile"
                                  )
                                }
                              />
                            }
                            label={data.name}
                          />
                        </FormGroup>
                      );
                    })}
                </div>
              </div>
              <div
                className="d-flex flex-row justify-content-center px-2 py-3"
                style={{ backgroundColor: "white", width: "350px" }}
              >
                <button
                  className="btn"
                  style={{
                    backgroundColor: Colors.Base_color,
                    color: Colors.white_color,
                  }}
                  onClick={handleApplyFilter}
                >
                  Apply Filter
                </button>
              </div>
            </div>
          </Modal>
        </div>
      </div>

      <Footer option={true} reload={setCallFun} />
    </>
  ) : (
    <div
      className="d-flex align-items-center justify-content-center ban-box w-100"
      style={{ height: "100vh" }}
    >
      <MutatingDots
        height="100"
        width="100"
        color={Colors.Base_color}
        secondaryColor={Colors.Base_color}
        radius="12.5"
        ariaLabel="mutating-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
}

export default Filter;
